import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { useLocation } from '../contexts/LocationContext';
import { useAuth } from '../contexts/AuthContext';
import { usePermissions } from '../contexts/PermissionsContext';

import {
  UploadStatusBar,
  PurchaseInvoiceStats,
  ImportPanel,
  QuickActions,
  RecentInvoices,
  OptimaImportModal,
  CennikImportModal,
  FakturaXmlModal,
  MultiCennikImportModal,
  MultiCennikProgress,
  MultiParagonImportModal,
  MultiParagonProgress,
  PdfProductsImportModal,
  usePurchaseImports
} from '../components/purchase';
import CsvXmlPricelistModal from '../components/purchase/CsvXmlPricelistModal';
import KontrahenciDoSparowaniaModal from '../components/purchase/KontrahenciDoSparowaniaModal';

const OptimaUpdateModal = ({ preview, onSave, onClose, loading }) => {
  const [options, setOptions] = useState({ update_names: true, update_purchase: true, update_retail: true, create_new: true });
  const products = preview?.products || [];
  const matched = products.filter(p => p.matched);
  const unmatched = products.filter(p => !p.matched);
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 2000, display: 'flex', justifyContent: 'center', alignItems: 'flex-start', padding: '2rem', overflowY: 'auto' }}>
      <div style={{ backgroundColor: 'var(--card-bg)', borderRadius: '8px', width: '100%', maxWidth: '900px', padding: '1.5rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <h5 style={{ margin: 0, fontSize: '15px', fontWeight: '700' }}>Aktualizacja cen z XML — podglad</h5>
          <button onClick={onClose} style={{ background: 'none', fontSize: '18px', cursor: 'pointer' }}>x</button>
        </div>
        {preview.numer_faktury && (
          <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginBottom: '0.75rem', padding: '0.5rem', backgroundColor: 'var(--bg)', borderRadius: '4px' }}>
            Faktura: <strong>{preview.numer_faktury}</strong> | Data: {preview.data_faktury} | Cennik: {preview.cennik_count} poz. | Dokument: {preview.dokument_count} poz.
          </div>
        )}
        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.75rem' }}>
          <div style={{ flex: 1, padding: '0.5rem', backgroundColor: 'var(--success-light)', borderRadius: '4px', textAlign: 'center', borderLeft: '3px solid var(--success)' }}>
            <div style={{ fontSize: '16px', fontWeight: '700', color: 'var(--success)' }}>{matched.length}</div>
            <div style={{ fontSize: '9px', color: 'var(--text-muted)' }}>Dopasowane</div>
          </div>
          <div style={{ flex: 1, padding: '0.5rem', backgroundColor: 'var(--danger-light)', borderRadius: '4px', textAlign: 'center', borderLeft: '3px solid var(--danger)' }}>
            <div style={{ fontSize: '16px', fontWeight: '700', color: 'var(--danger)' }}>{unmatched.length}</div>
            <div style={{ fontSize: '9px', color: 'var(--text-muted)' }}>Niedopasowane</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '0.75rem', fontSize: '12px' }}>
          {[{ key: 'update_names', label: 'Aktualizuj nazwy' }, { key: 'update_purchase', label: 'Aktualizuj ceny zakupu' }, { key: 'update_retail', label: 'Aktualizuj ceny detaliczne' }, { key: 'create_new', label: 'Utwórz nowe produkty' }].map(opt => (
            <label key={opt.key} style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}>
              <input type="checkbox" checked={options[opt.key]} onChange={e => setOptions(prev => ({ ...prev, [opt.key]: e.target.checked }))} />
              {opt.label}
            </label>
          ))}
        </div>
        <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid var(--border)', borderRadius: '4px' }}>
          <table style={{ width: '100%', fontSize: '10px', borderCollapse: 'collapse' }}>
            <thead style={{ position: 'sticky', top: 0, backgroundColor: 'var(--bg)' }}>
              <tr>
                {['LP', 'EAN', 'Nazwa', 'Cena zakupu', 'Cena detal.', 'VAT', 'Status'].map(h => (
                  <th key={h} style={{ padding: '0.4rem', borderBottom: '2px solid var(--border)', textAlign: 'left', fontWeight: '600', fontSize: '9px' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {products.map((p, idx) => (
                <tr key={idx} style={{ borderBottom: '1px solid var(--border)', backgroundColor: p.matched ? 'transparent' : 'var(--danger-light)' }}>
                  <td style={{ padding: '0.3rem 0.4rem', color: 'var(--text-muted)' }}>{idx + 1}</td>
                  <td style={{ padding: '0.3rem 0.4rem' }}><code style={{ fontSize: '9px' }}>{p.ean || p.kod}</code></td>
                  <td style={{ padding: '0.3rem 0.4rem', fontWeight: '500' }}>
                    {p.matched && p.db_nazwa !== p.nazwa ? (<div><div style={{ textDecoration: 'line-through', color: 'var(--text-muted)', fontSize: '9px' }}>{p.db_nazwa}</div><div>{p.nazwa}</div></div>) : p.nazwa}
                  </td>
                  <td style={{ padding: '0.3rem 0.4rem' }}>
                    {p.cena_zakupu_netto > 0 ? (<div>
                      {p.matched && p.db_cena_zakupu_netto > 0 && p.db_cena_zakupu_netto !== p.cena_zakupu_netto && (<span style={{ textDecoration: 'line-through', color: 'var(--text-muted)', fontSize: '9px', marginRight: '4px' }}>{p.db_cena_zakupu_netto.toFixed(2)}</span>)}
                      <span style={{ fontWeight: '600', color: 'var(--info)' }}>{p.cena_zakupu_netto.toFixed(2)} zl</span>
                    </div>) : '-'}
                  </td>
                  <td style={{ padding: '0.3rem 0.4rem' }}>
                    {p.cena_detaliczna_brutto > 0 ? (<div>
                      {p.matched && p.db_cena_sprzedazy_brutto > 0 && p.db_cena_sprzedazy_brutto !== p.cena_detaliczna_brutto && (<span style={{ textDecoration: 'line-through', color: 'var(--text-muted)', fontSize: '9px', marginRight: '4px' }}>{p.db_cena_sprzedazy_brutto.toFixed(2)}</span>)}
                      <span style={{ fontWeight: '600', color: 'var(--success)' }}>{p.cena_detaliczna_brutto.toFixed(2)} zl</span>
                    </div>) : '-'}
                  </td>
                  <td style={{ padding: '0.3rem 0.4rem' }}>{p.stawka_vat}%</td>
                  <td style={{ padding: '0.3rem 0.4rem' }}>
                    <span style={{ fontSize: '9px', padding: '2px 6px', borderRadius: '3px', color: '#fff', fontWeight: '600', backgroundColor: p.matched ? 'var(--success)' : 'var(--danger)' }}>
                      {p.matched ? 'OK' : 'Brak w bazie'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem' }}>
          <button onClick={onClose} style={{ flex: 1, padding: '6px 12px', border: '1px solid var(--text-muted)', fontSize: '12px', cursor: 'pointer', color: 'var(--text-secondary)', backgroundColor: 'var(--card-bg)' }}>Anuluj</button>
          <button onClick={() => onSave(options)} disabled={loading || matched.length === 0} style={{ flex: 2, padding: '6px 12px', border: '2px solid var(--success)', fontSize: '12px', cursor: 'pointer', fontWeight: '600', color: 'var(--success)', opacity: loading || matched.length === 0 ? 0.5 : 1 }}>
            {loading ? 'Zapisywanie...' : `Zastosuj (${matched.length} produktow)`}
          </button>
        </div>
      </div>
    </div>
  );
};

const PurchaseInvoicesPage = () => {
  const navigate = useNavigate();
  const { selectedLocation, locationId } = useLocation();
  const currentLocationId = locationId || selectedLocation?.id || selectedLocation?.location_id;

  // Gating panelu importu: kasjer widzi tylko Kreator, reszta opcji dla admina
  // lub uzytkownika z akcja faktury_zakupu.import_zaawansowany.
  // isAdmin bierzemy z AuthContext (user_type === 'admin'), NIE z PermissionsContext.
  const { isAdmin } = useAuth();
  const { hasPermission, loading: uprawnieniaLaduja } = usePermissions();
  // Lokalizacje przekazujemy JAWNIE, inaczej hook wziąłby pierwsza z /permissions/my
  const pokazZaawansowane = isAdmin || hasPermission('faktury_zakupu', 'import_zaawansowany', currentLocationId);

  const imports = usePurchaseImports(currentLocationId);

  // ===== Kolejka "faktury bez kontrahenta" =====
  // Bez widocznego licznika nikt tej kolejki nie otworzy i po miesiacu faktury
  // bez powiazania z kartoteka znowu beda norma.
  const [pokazSparowanie, setPokazSparowanie] = useState(false);
  const [licznikBezKontrahenta, setLicznikBezKontrahenta] = useState(null);

  const wczytajLicznikBezKontrahenta = useCallback(async () => {
    // 1) Preferujemy wartosc ze statystyk menu (jedno zapytanie mniej).
    const zeStatystyk =
      imports.stats?.invoices?.bez_kontrahenta ??
      imports.stats?.kontrahenci?.faktur_bez_kontrahenta ??
      null;
    if (zeStatystyk !== null && zeStatystyk !== undefined) {
      setLicznikBezKontrahenta(Number(zeStatystyk) || 0);
      return;
    }
    // 2) Fallback: liczymy z kolejki. Brak endpointu (starszy backend) zostawia
    //    licznik jako null - kafelek pokazuje sie wtedy w stanie neutralnym.
    try {
      const res = await api.get('/purchase-invoices/kontrahenci-do-sparowania');
      const body = res.data?.data ?? res.data;
      const lista = Array.isArray(body) ? body : (body?.items || body?.grupy || []);
      const suma = (Array.isArray(lista) ? lista : [])
        .reduce((s, g) => s + (parseInt(g.liczba_faktur, 10) || 0), 0);
      setLicznikBezKontrahenta(suma);
    } catch {
      setLicznikBezKontrahenta(null);
    }
  }, [imports.stats]);

  useEffect(() => { wczytajLicznikBezKontrahenta(); }, [wczytajLicznikBezKontrahenta]);

  if (imports.loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center', backgroundColor: 'var(--bg)', minHeight: '100vh' }}>
        <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>{'⏳'}</div>
        <div style={{ color: 'var(--text-muted)' }}>{'Ladowanie...'}</div>
      </div>
    );
  }

  return (
    <div style={{ fontSize: '12px' }}>
      {/* Header */}
      <div className="card" style={{ marginBottom: '16px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h2 style={{ fontSize: '16px', fontWeight: 600, marginBottom: '4px' }}>Faktury Zakupowe</h2>
            <p style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
              Import i zarz{'a'}dzanie fakturami | {new Date().toLocaleDateString()}
            </p>
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button className="btn btn-primary" onClick={() => navigate('/purchase-invoices/list')}>Lista faktur</button>
            <button className="btn btn-secondary" onClick={imports.loadMenuStats}>Odswiez</button>
          </div>
        </div>
      </div>

      {/* Error */}
      {imports.error && (
        <div style={{
          padding: '0.5rem 0.75rem', backgroundColor: 'var(--danger-light)', color: 'var(--danger)',
          borderRadius: '4px', marginBottom: '0.5rem', fontSize: '11px'
        }}>{'❌'} {imports.error}</div>
      )}

      {/* Upload status bar */}
      <UploadStatusBar
        uploadStatus={imports.uploadStatus}
        uploadProgress={imports.uploadProgress}
        onClear={imports.clearUploadStatus}
      />

      {/* Stats */}
      <PurchaseInvoiceStats stats={imports.stats} />

      {/* Kafelek kolejki "faktury bez kontrahenta" */}
      <div
        onClick={() => setPokazSparowanie(true)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setPokazSparowanie(true); }}
        style={{
          display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer',
          padding: '0.4rem 0.6rem', marginBottom: '0.75rem', borderRadius: '4px',
          backgroundColor: 'var(--card-bg)', boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
          borderLeft: `3px solid ${licznikBezKontrahenta > 0 ? 'var(--warning)' : 'var(--border)'}`
        }}
        title="Przypisz faktury zapisane bez kontrahenta do kart w kartotece"
      >
        <span style={{ fontSize: '9px', color: 'var(--text-muted)' }}>Faktury bez kontrahenta:</span>
        <span style={{
          fontSize: '14px', fontWeight: '700',
          color: licznikBezKontrahenta > 0 ? 'var(--warning)' : 'var(--text-muted)'
        }}>
          {licznikBezKontrahenta === null ? '—' : licznikBezKontrahenta}
        </span>
        <span style={{
          fontSize: '11px', padding: '4px 10px', borderRadius: '4px',
          border: `1px solid ${licznikBezKontrahenta > 0 ? 'var(--warning)' : 'var(--border)'}`,
          color: licznikBezKontrahenta > 0 ? 'var(--warning)' : 'var(--text-secondary)'
        }}>
          Sparuj kontrahent{'ó'}w
        </span>
      </div>

      {/* Main grid: Import | Actions | Recent */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '0.75rem' }}>
        <ImportPanel
          pokazZaawansowane={pokazZaawansowane}
          uprawnieniaLaduja={uprawnieniaLaduja}
          onOpenKreator={() => navigate('/purchase-invoices/kreator')}
          xmlInputRef={imports.xmlInputRef}
          paragonInputRef={imports.paragonInputRef}
          pdfInputRef={imports.pdfInputRef}
          pdfProductsInputRef={imports.pdfProductsInputRef}
          cennikInputRef={imports.cennikInputRef}
          cennikMultipleInputRef={imports.cennikMultipleInputRef}
          optimaInputRef={imports.optimaInputRef}
          sfdInputRef={imports.sfdInputRef}
          xmlValidationInputRef={imports.xmlValidationInputRef}
          handleFileUpload={imports.handleFileUpload}
          handleOptimaUpload={imports.handleOptimaUpload}
          handleSfdUpload={imports.handleSfdUpload}
          handleMultipleCennikUpload={imports.handleMultipleCennikUpload}
          paragonMultipleInputRef={imports.paragonMultipleInputRef}
          handleMultipleParagonUpload={imports.handleMultipleParagonUpload}
          updateProductNames={imports.updateProductNames}
          setUpdateProductNames={imports.setUpdateProductNames}
          pendingPdfFile={imports.pendingPdfFile}
          pendingPdfType={imports.pendingPdfType}
          onPdfSelect={imports.onPdfSelect}
          onXmlValidationSelect={imports.onXmlValidationSelect}
          optimaUpdateCennikRef={imports.optimaUpdateCennikRef}
          optimaUpdateDokumentRef={imports.optimaUpdateDokumentRef}
          optimaUpdateCennikFile={imports.optimaUpdateCennikFile}
          optimaUpdateDokumentFile={imports.optimaUpdateDokumentFile}
          onOptimaUpdateCennik={imports.onOptimaUpdateCennik}
          onOptimaUpdateDokument={imports.onOptimaUpdateDokument}
          onOptimaUpdateImport={imports.onOptimaUpdateImport}
          cennikOnlyFile={imports.cennikOnlyFile}
          onCennikOnlyFileChange={imports.onCennikOnlyFileChange}
          onCennikOnlyImport={imports.handleCennikOnlyImport}
          csvXmlCsvFile={imports.csvXmlCsvFile}
          setCsvXmlCsvFile={imports.setCsvXmlCsvFile}
          csvXmlXmlFile={imports.csvXmlXmlFile}
          setCsvXmlXmlFile={imports.setCsvXmlXmlFile}
          handleCsvXmlImport={imports.handleCsvXmlImport}
        />
        <QuickActions pokazZaawansowane={pokazZaawansowane} />
        <RecentInvoices recentInvoices={imports.stats?.recent_invoices} />
      </div>

      {/* Modals */}
      {imports.showOptimaModal && (
        <OptimaImportModal
          optimaPreview={imports.optimaPreview}
          optimaOptions={imports.optimaOptions}
          setOptimaOptions={imports.setOptimaOptions}
          warehouses={imports.warehouses}
          isSaving={imports.isSaving}
          onSave={imports.saveOptimaImport}
          onClose={imports.closeOptimaModal}
        />
      )}

      {imports.showCennikModal && (
        <CennikImportModal
          cennikPreview={imports.cennikPreview}
          cennikOptions={imports.cennikOptions}
          setCennikOptions={imports.setCennikOptions}
          cennikFilter={imports.cennikFilter}
          setCennikFilter={imports.setCennikFilter}
          cennikSearch={imports.cennikSearch}
          setCennikSearch={imports.setCennikSearch}
          isSavingCennik={imports.isSavingCennik}
          getFilteredCennikProducts={imports.getFilteredCennikProducts}
          onSave={imports.saveCennikImport}
          onClose={imports.closeCennikModal}
        />
      )}

      {imports.showFakturaModal && (
        <FakturaXmlModal
          fakturaPreview={imports.fakturaPreview}
          isSavingFaktura={imports.isSavingFaktura}
          onSave={() => imports.saveFakturaImport()}
          onClose={imports.closeFakturaModal}
          // Bez pokrycia w cenniku zapis jest zablokowany takze tutaj - musi byc
          // widoczne wyjscie do Kreatora, inaczej jedynym wyjsciem jest "Anuluj".
          onPrzejdzDoKreatora={() => navigate('/purchase-invoices/kreator')}
          // Przy kilku kartach z tym samym NIP-em uzytkownik wskazuje wlasciwa,
          // a jej ID jedzie do zapisu razem z obiektem invoice.
          onWybierzKontrahenta={(klientId) => imports.setFakturaPreview(prev => (
            prev ? {
              ...prev,
              invoice: { ...prev.invoice, customer_id: klientId },
              kontrahent_podglad: { ...(prev.kontrahent_podglad || {}), wybrany_id: klientId }
            } : prev
          ))}
        />
      )}

      {/* Kolejka kontrahentow do sparowania */}
      {pokazSparowanie && (
        <KontrahenciDoSparowaniaModal
          onClose={() => setPokazSparowanie(false)}
          onZmiana={() => { imports.loadMenuStats(); wczytajLicznikBezKontrahenta(); }}
        />
      )}

      <MultiCennikProgress progress={imports.multiCennikProgress} />

      {/* Zbiorczy import paragonow: postep + raport per plik i lista wszystkich produktow */}
      <MultiParagonProgress progress={imports.multiParagonProgress} />
      {imports.showMultiParagonModal && (
        <MultiParagonImportModal
          wynik={imports.multiParagonWynik}
          onClose={imports.closeMultiParagonModal}
          onOtworzFakture={(id) => { imports.closeMultiParagonModal(); navigate(`/purchase-invoices/${id}`); }}
        />
      )}

      {imports.showMultiCennikModal && (
        <MultiCennikImportModal
          multiCennikPreview={imports.multiCennikPreview}
          cennikOptions={imports.cennikOptions}
          setCennikOptions={imports.setCennikOptions}
          multiCennikFilter={imports.multiCennikFilter}
          setMultiCennikFilter={imports.setMultiCennikFilter}
          multiCennikSearch={imports.multiCennikSearch}
          setMultiCennikSearch={imports.setMultiCennikSearch}
          isSavingMultiCennik={imports.isSavingMultiCennik}
          getFilteredMultiCennikProducts={imports.getFilteredMultiCennikProducts}
          onSave={imports.saveMultiCennikImport}
          onClose={imports.closeMultiCennikModal}
        />
      )}

      {imports.showPdfProductsModal && (
        <PdfProductsImportModal
          preview={imports.pdfProductsPreview}
          options={imports.pdfProductsOptions}
          setOptions={imports.setPdfProductsOptions}
          filter={imports.pdfProductsFilter}
          setFilter={imports.setPdfProductsFilter}
          search={imports.pdfProductsSearch}
          setSearch={imports.setPdfProductsSearch}
          isSaving={imports.isSavingPdfProducts}
          getFiltered={imports.getFilteredPdfProducts}
          onSave={imports.savePdfProductsImport}
          onClose={imports.closePdfProductsModal}
        />
      )}

      {/* Modal aktualizacji cen z XML */}
      {imports.showOptimaUpdateModal && imports.optimaUpdatePreview && (
        <OptimaUpdateModal
          preview={imports.optimaUpdatePreview}
          onSave={imports.handleOptimaUpdateSave}
          onClose={() => imports.setShowOptimaUpdateModal(false)}
          loading={imports.loading}
        />
      )}

      {/* Modal CSV + XML pricelist */}
      {imports.showCsvXmlModal && imports.csvXmlPreview && (
        <CsvXmlPricelistModal
          preview={imports.csvXmlPreview}
          options={imports.csvXmlOptions}
          setOptions={imports.setCsvXmlOptions}
          search={imports.csvXmlSearch}
          setSearch={imports.setCsvXmlSearch}
          filter={imports.csvXmlFilter}
          setFilter={imports.setCsvXmlFilter}
          isSaving={imports.isSavingCsvXml}
          onSave={imports.saveCsvXmlImport}
          onClose={imports.closeCsvXmlModal}
        />
      )}

      {/* Modal cennika — preview cen detalicznych + VAT */}
      {imports.showCennikOnlyModal && imports.cennikOnlyPreview && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 2000 }}>
          <div style={{ backgroundColor: 'var(--card-bg)', borderRadius: '8px', width: '90%', maxWidth: '800px', maxHeight: '80vh', display: 'flex', flexDirection: 'column', boxShadow: '0 1rem 3rem rgba(0,0,0,0.2)' }}>
            <div style={{ padding: '1rem', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <h5 style={{ margin: 0, fontSize: '14px' }}>Aktualizacja z cennika XML</h5>
                <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
                  Znaleziono: {imports.cennikOnlyPreview.matched} | Pominięto: {imports.cennikOnlyPreview.skipped} | Ze zmianami: {imports.cennikOnlyPreview.preview?.filter(p => p.changed).length || 0}
                </span>
              </div>
              <button onClick={() => imports.setCennikOnlyModal(false)} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: 'var(--text-muted)' }}>x</button>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', padding: '0.5rem' }}>
              <table style={{ width: '100%', fontSize: '11px', borderCollapse: 'collapse' }}>
                <thead style={{ position: 'sticky', top: 0, backgroundColor: 'var(--bg)' }}>
                  <tr>
                    {['LP', 'Produkt', 'EAN', 'VAT (stary)', 'VAT (nowy)', 'Cena detal. (stara)', 'Cena detal. (nowa)', 'Status'].map(h => (
                      <th key={h} style={{ padding: '0.4rem', borderBottom: '2px solid var(--border)', textAlign: 'left', fontSize: '10px', fontWeight: '600' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {(imports.cennikOnlyPreview.preview || []).map((p, i) => (
                    <tr key={i} style={{ borderBottom: '1px solid var(--border)', backgroundColor: p.changed ? 'rgba(255,193,7,0.05)' : 'transparent' }}>
                      <td style={{ padding: '0.3rem 0.4rem', color: 'var(--text-muted)' }}>{i + 1}</td>
                      <td style={{ padding: '0.3rem 0.4rem', fontWeight: '500' }}>{p.nazwa}</td>
                      <td style={{ padding: '0.3rem 0.4rem', fontSize: '10px' }}>{p.ean}</td>
                      <td style={{ padding: '0.3rem 0.4rem', color: p.vat_changed ? 'var(--danger)' : 'var(--text-muted)' }}>{p.old_vat}%</td>
                      <td style={{ padding: '0.3rem 0.4rem', color: p.vat_changed ? 'var(--success)' : 'var(--text-muted)', fontWeight: p.vat_changed ? '700' : '400' }}>{p.new_vat}%</td>
                      <td style={{ padding: '0.3rem 0.4rem', color: p.price_changed ? 'var(--danger)' : 'var(--text-muted)' }}>{p.old_price?.toFixed(2)} zł</td>
                      <td style={{ padding: '0.3rem 0.4rem', color: p.price_changed ? 'var(--success)' : 'var(--text-muted)', fontWeight: p.price_changed ? '700' : '400' }}>{p.new_price?.toFixed(2)} zł</td>
                      <td style={{ padding: '0.3rem 0.4rem' }}>
                        {p.changed ? (
                          <span style={{ fontSize: '9px', padding: '2px 6px', borderRadius: '3px', backgroundColor: 'var(--warning)', color: '#000', fontWeight: '600' }}>Zmiana</span>
                        ) : (
                          <span style={{ fontSize: '9px', padding: '2px 6px', borderRadius: '3px', backgroundColor: 'var(--success)', color: '#fff' }}>OK</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ padding: '0.75rem', borderTop: '1px solid var(--border)', display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
              <button onClick={() => imports.setCennikOnlyModal(false)} style={{ padding: '6px 12px', fontSize: '12px', border: '1px solid var(--text-muted)', cursor: 'pointer', color: 'var(--text-muted)', backgroundColor: 'var(--card-bg)' }}>Anuluj</button>
              <button onClick={imports.handleCennikOnlySave} disabled={!imports.cennikOnlyPreview.preview?.some(p => p.changed)} style={{ padding: '6px 12px', fontSize: '12px', border: '1px solid var(--purple, #6f42c1)', cursor: 'pointer', color: '#fff', backgroundColor: 'var(--purple, #6f42c1)', fontWeight: '600' }}>
                Zastosuj zmiany ({imports.cennikOnlyPreview.preview?.filter(p => p.changed).length || 0})
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PurchaseInvoicesPage;
